/* eslint-disable react/jsx-curly-newline */
import React from "react";
import { FormattedMessage, Link } from "gatsby-plugin-intl";
import { useServiceModalsContext } from "components/ServicesModals/context";
import { SERVICES_KEYS } from "shared/constants/services";
import facebook from "icons/facebook.svg";
import instagram from "icons/instagram.svg";
import youtube from "icons/youtube.svg";
import { gtagsActions, gtagsCategories, gtagsSend } from "utils/gtagsUtils";
import logoImg from "../../images/logo.png";
import Card from "./Card";

const FastAccessLink = ({ label, to, ...props }) => (
  <Link
    className=" hover:text-gray-400 transition-colors ease-in-out duration-150"
    to={to}
    {...props}
  >
    {label}
  </Link>
);

const Footer = () => {
  const servicesModal = useServiceModalsContext();

  const openServiceModal = key => {
    servicesModal.openModal(key);
  };

  return (
    <footer className="py-12 bg-white  text-black">
      <div className="container m-auto flex flex-wrap justify-between items-stretch">
        <div className="w-full md:w-3/12 mb-12 md:mb-0">
          <img src={logoImg} alt="Chaabicash.ma" className="w-64" />
        </div>

        <div className="w-full sm:w-1/2 md:w-4/12 flex mb-5 md:mb-0">
          <div className="w-full md:w-2/3 ltr:pr-4 rtl:pl-4 mx-2 md:mx-auto">
            <h3 className="mb-4 uppercase opacity-50">
              <FormattedMessage id="footer.fastAccess" />
            </h3>

            <div className="flex items-center">
              <ul className="w-full ltr:pr-4 rtl:pl-4">
                <li className="mb-2">
                  <FastAccessLink
                    to="/#branches"
                    label={<FormattedMessage id="footer.find-agency" />}
                    onClick={() =>
                      gtagsSend(
                        gtagsCategories.SEARCH,
                        gtagsActions.FIND_AGENCY
                      )
                    }
                  />
                </li>

                <li className="mb-2">
                  <FastAccessLink
                    to="/#branches"
                    label={
                      <FormattedMessage id="chaabiServices.nationalTransfer.title" />
                    }
                  />
                </li>

                <li className="mb-2">
                  <FastAccessLink
                    onClick={() =>
                      openServiceModal(SERVICES_KEYS.INTERNATIONAL_TRANSFER)
                    }
                    to="/#services"
                    label={
                      <FormattedMessage id="chaabiServices.internationalTransfer.title" />
                    }
                  />
                </li>

                <li className="mb-2">
                  <FastAccessLink
                    to="/#branches"
                    label={
                      <FormattedMessage id="chaabiServices.exchange.title" />
                    }
                  />
                </li>

                <li className="mb-2">
                  <FastAccessLink
                    onClick={() => openServiceModal(SERVICES_KEYS.BILL_PAYMENT)}
                    to="/#services"
                    label={
                      <FormattedMessage id="chaabiServices.billPayment.title" />
                    }
                  />
                </li>

                <li className="mb-2">
                  <FastAccessLink
                    onClick={() =>
                      openServiceModal(SERVICES_KEYS.INSURANCE_AND_CNSS)
                    }
                    to="/#services"
                    label={
                      <FormattedMessage id="chaabiServices.insuranceAndCNSS.title" />
                    }
                  />
                </li>

                <li className="mb-2">
                  <FastAccessLink
                    onClick={() =>
                      openServiceModal(
                        SERVICES_KEYS.TICKETING_AND_TRANSPORTATION
                      )
                    }
                    to="/#services"
                    label={
                      <FormattedMessage id="chaabiServices.ticketingAndTransportation.title" />
                    }
                  />
                </li>

                <li className="mb-2">
                  <FastAccessLink
                    onClick={() => openServiceModal(SERVICES_KEYS.TAXES)}
                    to="/#services"
                    label={<FormattedMessage id="chaabiServices.taxes.title" />}
                  />
                </li>

                <li className="mb-2">
                  <FastAccessLink
                    onClick={() => openServiceModal(SERVICES_KEYS.REFILL)}
                    to="/#services"
                    label={
                      <FormattedMessage id="chaabiServices.refill.title" />
                    }
                  />
                </li>
              </ul>
            </div>
          </div>
        </div>

        <div className="w-full sm:w-1/2 md:w-5/12 flex fkex-col flex-grow flex-wrap p-2">
          <div className="flex flex-wrap justify-around w-full">
            <Card text="footer.who-we-are" to="/#who-we-are" />
            <Card text="footer.contact-us" to="/#contact-us" />
          </div>

          <div className="mt-5 md:mt-auto md:ltr:ml-auto md:rtl:mr-auto">
            <ul className="flex">
              <li className="ltr:mr-3 rtl:ml-3">
                <a
                  rel="noreferrer"
                  target="_blank"
                  href="https://www.instagram.com/chaabicash/"
                >
                  <object
                    width="25"
                    className="pointer-events-none"
                    aria-label="instagram"
                    data={instagram}
                  />
                </a>
              </li>

              <li className="ltr:mr-3 rtl:ml-3">
                <a
                  rel="noreferrer"
                  target="_blank"
                  href="https://www.facebook.com/chaabicashMA"
                >
                  <object
                    width="25"
                    className="pointer-events-none"
                    aria-label="facebook"
                    data={facebook}
                  />
                </a>
              </li>

              <li className="ltr:mr-3 rtl:ml-3">
                <a
                  rel="noreferrer"
                  target="_blank"
                  href="https://www.youtube.com/channel/UC1kcUMOnBa2dkmVpDtDL1Ww"
                >
                  <object
                    width="25"
                    className="pointer-events-none"
                    aria-label="youtube"
                    data={youtube}
                  />
                </a>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
